(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4767],{

/***/ 84296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NB": function() { return /* binding */ getAndSetDealDetails; },
/* harmony export */   "NZ": function() { return /* binding */ setSelectedApplicationType; },
/* harmony export */   "fP": function() { return /* binding */ updateSelectedDeviceColor; },
/* harmony export */   "lC": function() { return /* binding */ updateSelectedInclusionColor; },
/* harmony export */   "rv": function() { return /* binding */ updateSelectedDealDetail; }
/* harmony export */ });
/* unused harmony exports getAndSetWhitelistedRouters, getAndSetRelatedDeals */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71404);
/* harmony import */ var utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72490);
/* harmony import */ var utils_ajaxServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18517);
/* harmony import */ var _config_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91250);






var getAndSetDealDetails = function getAndSetDealDetails(url_key) {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
      var _result$products, _result$products2, _result$products2$ite, _result$products3, _result$products4, _result$products5, _result$products6;

      var queryVariables, result, contractsDurations, activeDealValue, allProductsUnderContract, isDoubleDeal, primaryProduct, secondaryProduct, anyTimeDataSku, planDetails, extraProductsUnderContract, allExtraItems, primaryProductColors, secondaryProductColors, dealInclusionColors, selectedPrimaryDeviceColor, selectedSecondaryDeviceColor, showError;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (url_key) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", {
                ok: false,
                isError: true
              });

            case 2:
              queryVariables = {
                url_key: url_key
              };
              _context.next = 5;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_4__/* .DealDetail */ .Xv, queryVariables, "", true, false, {
                headers: {
                  'Cache-Control': 'max-age=300'
                }
              });

            case 5:
              result = _context.sent;

              if (!(!result || !result.products || !Array.isArray(result.products.items) || !result.products.items.length)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", {
                ok: false,
                isError: true,
                status: result.status
              });

            case 8:
              contractsDurations = result === null || result === void 0 ? void 0 : (_result$products = result.products) === null || _result$products === void 0 ? void 0 : _result$products.items.map(function (contract) {
                return {
                  id: contract.sku,
                  duration: contract.payment_terms_label,
                  price: contract.monthly_recurring,
                  old_installment: contract.old_installment,
                  old_monthly_recurring: contract.old_monthly_recurring,
                  old_tariff: contract.old_tariff
                };
              });
              activeDealValue = result === null || result === void 0 ? void 0 : (_result$products2 = result.products) === null || _result$products2 === void 0 ? void 0 : (_result$products2$ite = _result$products2.items) === null || _result$products2$ite === void 0 ? void 0 : _result$products2$ite.find(function (item) {
                return item.url_key === url_key;
              });
              allProductsUnderContract = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .extractProductList */ .T9)(activeDealValue);
              isDoubleDeal = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .isDoubleDealDevice */ .np)(allProductsUnderContract);
              primaryProduct = allProductsUnderContract.find(function (item) {
                return item.isPrimary;
              }) || null;
              secondaryProduct = isDoubleDeal ? allProductsUnderContract.find(function (item) {
                return item.isSecondary || item.optionQuantity > 1;
              }) : null;
              anyTimeDataSku = activeDealValue === null || activeDealValue === void 0 ? void 0 : activeDealValue.anytime_product_sku;
              planDetails = allProductsUnderContract.find(function (item) {
                return item.sku === anyTimeDataSku;
              }) || null;
              extraProductsUnderContract = allProductsUnderContract.filter(function (item) {
                return !item.isPrimary && item.sku !== (secondaryProduct === null || secondaryProduct === void 0 ? void 0 : secondaryProduct.sku) && item.sku !== anyTimeDataSku;
              });
              allExtraItems = [];
              extraProductsUnderContract.forEach(function (extraItem) {
                for (var i = 0; i < extraItem.optionQuantity; i++) {
                  allExtraItems.push(extraItem);
                }
              });
              extraProductsUnderContract = allExtraItems;
              primaryProductColors = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .extractDeviceColorOptions */ .HR)(primaryProduct);
              secondaryProductColors = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .extractDeviceColorOptions */ .HR)(secondaryProduct);
              dealInclusionColors = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .extractInclusionColorOptions */ .y9)(extraProductsUnderContract);
              selectedPrimaryDeviceColor = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .selectInitialColor */ .vi)(primaryProductColors);
              selectedSecondaryDeviceColor = (0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .selectInitialColor */ .vi)(secondaryProductColors);
              dispatch({
                type: Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__/* .SET_ALL_DEAL_DATA */ .NR,
                payload: {
                  attributeCodes: Array.isArray((_result$products3 = result.products) === null || _result$products3 === void 0 ? void 0 : _result$products3.attribute_set_config) ? (_result$products4 = result.products) === null || _result$products4 === void 0 ? void 0 : _result$products4.attribute_set_config : [],
                  dealList: (result === null || result === void 0 ? void 0 : (_result$products5 = result.products) === null || _result$products5 === void 0 ? void 0 : _result$products5.items) || [],
                  contractsDurations: contractsDurations,
                  contractsList: Array.isArray(result.contract_type_desc) ? result.contract_type_desc : [],
                  dataPlanDetails: planDetails,
                  dealInclusions: extraProductsUnderContract,
                  dealInclusionColors: dealInclusionColors,
                  primaryProductColors: primaryProductColors,
                  primaryProduct: primaryProduct,
                  relatedDeals: activeDealValue === null || activeDealValue === void 0 ? void 0 : activeDealValue.related_products,
                  secondaryProduct: secondaryProduct,
                  secondaryProductColors: secondaryProductColors,
                  selectedDealDetails: activeDealValue,
                  selectedPrimaryDeviceColor: selectedPrimaryDeviceColor,
                  selectedSecondaryDeviceColor: selectedSecondaryDeviceColor,
                  similarDeals: (activeDealValue === null || activeDealValue === void 0 ? void 0 : activeDealValue.upsell_products) || []
                }
              });
              showError = !activeDealValue;
              return _context.abrupt("return", {
                ok: true,
                isError: showError,
                status: result.status,
                productItem: result === null || result === void 0 ? void 0 : (_result$products6 = result.products) === null || _result$products6 === void 0 ? void 0 : _result$products6.items[0]
              });

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var setSelectedApplicationType = function setSelectedApplicationType(buyOption) {
  return function (dispatch) {
    if (typeof buyOption !== "object" || !(buyOption !== null && buyOption !== void 0 && buyOption.option_type_id) || !buyOption.title) return;
    dispatch({
      type: Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__/* .SET_APPLICATION_TYPE */ .QH,
      payload: buyOption
    });
  };
};
var getAndSetWhitelistedRouters = function getAndSetWhitelistedRouters() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _fiveGRouters$product;

      var fiveGRouters;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ajaxService.fetchGraphQLPOSTRequest(GetAll5GRoutersQuery);

            case 2:
              fiveGRouters = _context2.sent;

              if (isValidRouterResponse(fiveGRouters)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              dispatch({
                type: DealDetailsActionTypes.SET_WHITELISTED_ROUTERS,
                payload: fiveGRouters === null || fiveGRouters === void 0 ? void 0 : (_fiveGRouters$product = fiveGRouters.products) === null || _fiveGRouters$product === void 0 ? void 0 : _fiveGRouters$product.items
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getAndSetRelatedDeals = function getAndSetRelatedDeals(manufacturerId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var _result$products7, _result$products8;

      var result, _result$error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (manufacturerId) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", {
                ok: false,
                error: new Error("Invalid params given")
              });

            case 2:
              _context3.next = 4;
              return ajaxService.fetchGraphQLGetRequest(RelatedDealsQuery, {
                manufacturer: manufacturerId
              });

            case 4:
              result = _context3.sent;

              if (!(!result || !Array.isArray(result === null || result === void 0 ? void 0 : (_result$products7 = result.products) === null || _result$products7 === void 0 ? void 0 : _result$products7.items))) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", {
                error: result.error,
                ok: false,
                status: result.status || (result === null || result === void 0 ? void 0 : (_result$error = result.error) === null || _result$error === void 0 ? void 0 : _result$error.status)
              });

            case 7:
              dispatch({
                type: DealDetailsActionTypes.SET_RELATED_DEALS,
                payload: (_result$products8 = result.products) === null || _result$products8 === void 0 ? void 0 : _result$products8.items
              });
              return _context3.abrupt("return", {
                ok: true,
                status: result.status
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var updateSelectedDealDetail = function updateSelectedDealDetail(dealSku) {
  return function (dispatch) {
    if (!dealSku) return;
    dispatch({
      type: Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__/* .SET_DEAL_DETAILS */ .HP,
      payload: {
        dealSku: dealSku
      }
    });
  };
};
var updateSelectedDeviceColor = function updateSelectedDeviceColor(_ref4) {
  var primaryDeviceColor = _ref4.primaryDeviceColor,
      secondaryDeviceColor = _ref4.secondaryDeviceColor;
  return function (dispatch) {
    if (!(0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .isValidDeviceColor */ .U6)(primaryDeviceColor) && !(0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .isValidDeviceColor */ .U6)(secondaryDeviceColor)) return;
    dispatch({
      type: Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__/* .SET_DEVICE_COLOR */ .tj,
      payload: {
        primaryDeviceColor: primaryDeviceColor,
        secondaryDeviceColor: secondaryDeviceColor
      }
    });
  };
};
var updateSelectedInclusionColor = function updateSelectedInclusionColor(inclusionSku, inclusionColor) {
  return function (dispatch) {
    if (!inclusionSku || !(0,utils_dealDetails__WEBPACK_IMPORTED_MODULE_1__/* .isValidDeviceColor */ .U6)(inclusionColor)) return;
    dispatch({
      type: Redux_actionTypes__WEBPACK_IMPORTED_MODULE_5__/* .SET_INCLUSION_COLOR */ .WU,
      payload: {
        inclusionSku: inclusionSku,
        inclusionColor: inclusionColor
      }
    });
  };
};

/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88447);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var LabelText = function LabelText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClickHandler = _ref.onClickHandler,
      uniqueLabelId = _ref.uniqueLabelId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
    className: "".concat(className, " ").concat((_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["label-text"])),
    style: style,
    onClick: onClickHandler,
    id: uniqueLabelId,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LabelText);

/***/ }),

/***/ 97984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18517);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28658);
/* harmony import */ var _upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27575);
/* harmony import */ var _services_upgradeService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70098);
/* harmony import */ var services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69152);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99599);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var AffordabilityContainer = function AffordabilityContainer(_ref) {
  var showModal = _ref.showModal,
      toggleModal = _ref.toggleModal,
      resultCode = _ref.resultCode,
      profileData = _ref.profileData,
      userLoggedIn = _ref.userLoggedIn,
      upgradeResponse = _ref.upgradeResponse;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      displayData = _useState[0],
      setDisplayData = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      selectedNumber = _useState2[0],
      setSelectedNumber = _useState2[1];

  var router = (0,_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_10___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_10___default().envConfigs)[env].imagePrefix;

  var getUtagViewData = function getUtagViewData() {
    return (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
  };

  var ctaRedirection = function ctaRedirection(route) {
    var pageName = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_name"]).page_name;
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .link */ .p4)(_objectSpread({
      page_tool_event: "o",
      page_tool_name: "".concat(pageName, ": show deals")
    }, getUtagViewData()));
    router.push(route);
  };

  var handleNewSelect = function handleNewSelect(selectedValue) {
    setSelectedNumber(selectedValue);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    function fetchDisplayData() {
      return _fetchDisplayData.apply(this, arguments);
    }

    function _fetchDisplayData() {
      _fetchDisplayData = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var affordData, dropdownData, responseData, _responseData$, _responseData$2, _responseData$3, _responseData$4, _responseData$5, _responseData$6, _responseData$7, _responseData$8;

        return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                affordData = {};
                dropdownData = [{
                  num: upgradeResponse.msisdn,
                  id: 1,
                  label: upgradeResponse.upgradeEligible ? "".concat((0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_7__/* .maskMsisdn */ .Ly)(upgradeResponse.msisdn), " (Upgradeable)") : "".concat((0,_services_upgradeService__WEBPACK_IMPORTED_MODULE_7__/* .maskMsisdn */ .Ly)(upgradeResponse.msisdn), " (Not upgradeable)"),
                  upgradeEligible: upgradeResponse.upgradeEligible
                }];
                setSelectedNumber(dropdownData[0].label);
                _context.next = 5;
                return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_4__/* ["default"].httpGet */ .Z.httpGet("drupalBaseUrl", "", "api", "upgradeResult", [resultCode]);

              case 5:
                responseData = _context.sent;

                if (responseData.length) {
                  affordData = {
                    iconUrl: ((_responseData$ = responseData[0]) === null || _responseData$ === void 0 ? void 0 : _responseData$.icon) || "",
                    title: ((_responseData$2 = responseData[0]) === null || _responseData$2 === void 0 ? void 0 : _responseData$2.resultTitle) || "",
                    analyticsTitle: ((_responseData$3 = responseData[0]) === null || _responseData$3 === void 0 ? void 0 : _responseData$3.analyticTitle) || "",
                    description: (_responseData$4 = responseData[0]) !== null && _responseData$4 !== void 0 && _responseData$4.resultHTML ? (_responseData$5 = responseData[0]) === null || _responseData$5 === void 0 ? void 0 : _responseData$5.resultHTML : ((_responseData$6 = responseData[0]) === null || _responseData$6 === void 0 ? void 0 : _responseData$6.resultText) || "",
                    primaryButtonText: ((_responseData$7 = responseData[0]) === null || _responseData$7 === void 0 ? void 0 : _responseData$7.primaryEnabled) === "Yes" ? (_responseData$8 = responseData[0]) === null || _responseData$8 === void 0 ? void 0 : _responseData$8.primaryCTAText : null,
                    onClickHandlerPrimary: function onClickHandlerPrimary() {
                      var _responseData$9;

                      return ctaRedirection((_responseData$9 = responseData[0]) === null || _responseData$9 === void 0 ? void 0 : _responseData$9.primaryCTAURL);
                    },
                    dropdown: true,
                    handleVal: handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData: dropdownData
                  };
                } else {
                  affordData = {
                    iconUrl: "".concat(imagePrefix, "/assets/images/icon-info.svg"),
                    title: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_title */ .Z.upgrade.lbl_afford_title,
                    description: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_desc */ .Z.upgrade.lbl_afford_desc,
                    primaryButtonText: _config_labels__WEBPACK_IMPORTED_MODULE_9__/* ["default"].upgrade.lbl_afford_btn */ .Z.upgrade.lbl_afford_btn,
                    onClickHandlerPrimary: ctaRedirection("/shopping/deals"),
                    dropdown: true,
                    handleVal: handleNewSelect,
                    selectedDropdownValue: selectedNumber ? selectedNumber : dropdownData[0].label,
                    dropdownData: dropdownData
                  };
                }

                setDisplayData(affordData);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchDisplayData.apply(this, arguments);
    }

    fetchDisplayData();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var userMetaData = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getProfileData */ .$y)(userLoggedIn, profileData);
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .view */ .ei)(_objectSpread(_objectSpread({
      page_event: "view",
      page_name: displayData.analyticsTitle,
      page_channel: "shopping",
      page_master_tab: "personal"
    }, (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
      upgrade_eligibility_status: "".concat(upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.upgradeEligible ? upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeEligible : false),
      upgrade_eligible_date: (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) || "",
      upgrade_ineligible_reason: !(upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.upgradeEligible) ? "".concat(displayData.title) : null,
      upgrade_customer_type: upgradeResponse ? null : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.c3dCustomer ? "C3D" : upgradeResponse !== null && upgradeResponse !== void 0 && upgradeResponse.business ? "EBU" : "Legacy"
    }, userMetaData));
  }, [displayData]);

  var hideModal = function hideModal() {
    var pageName = (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .getUtagData */ .GS)(["page_name"]).page_name;
    (0,services_analyticsUtag__WEBPACK_IMPORTED_MODULE_8__/* .link */ .p4)(_objectSpread({
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": dismiss")
    }, getUtagViewData()));
    toggleModal();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_upgradeModal_UpgradeModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    showModal: showModal,
    displayData: displayData,
    toggleModal: hideModal
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    upgradeResponse: state.upgrade.upgradeResponse
  };
};

/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, {})(AffordabilityContainer));

/***/ }),

/***/ 61297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var components_atoms_image_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39489);
/* harmony import */ var components_atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38975);
/* harmony import */ var _AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59107);
/* harmony import */ var _AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99599);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26125);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








var env = (_config__WEBPACK_IMPORTED_MODULE_4___default().env);
var imagePrefix = (_config__WEBPACK_IMPORTED_MODULE_4___default().envConfigs)[env].imagePrefix;

var AddedToCartPopup = function AddedToCartPopup(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Modal, {
    show: props.showModal,
    onHide: props.onCloseModal,
    dialogClassName: "custom-dialog",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: (_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_image_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: (_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default().img),
        img_path: "".concat(imagePrefix).concat(props.imageUrl),
        img_width: "2.5rem",
        img_height: "2.5rem"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_label_LabelText__WEBPACK_IMPORTED_MODULE_2__["default"], {
        className: (_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_item_add_success */ .Z.lbl_item_add_success
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Button, {
        variant: "dark",
        className: (_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btn),
        block: true,
        onClick: props.viewCart,
        id: "".concat(props.dealSKU, "-ViewCartMobile"),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_view_cart */ .Z.lbl_view_cart
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Button, {
        variant: "link",
        className: (_AddedToCartPopup_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["btn-link"]),
        onClick: props.onContinueShopping,
        id: "".concat(_config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_continue_shopping */ .Z.lbl_continue_shopping, "-btn"),
        children: _config_labels__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lbl_continue_shopping */ .Z.lbl_continue_shopping
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AddedToCartPopup);

/***/ }),

/***/ 65688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ov": function() { return /* binding */ tagJourneyChangeDismiss; },
/* harmony export */   "Rx": function() { return /* binding */ tagViewCart; },
/* harmony export */   "dL": function() { return /* binding */ generateAnalyticsData; },
/* harmony export */   "jc": function() { return /* binding */ tagJourneyChange; },
/* harmony export */   "l7": function() { return /* binding */ tagSessionUpdate; },
/* harmony export */   "lt": function() { return /* binding */ tagJourneyChangeUse; },
/* harmony export */   "sD": function() { return /* binding */ tagContinueShopping; }
/* harmony export */ });
/* unused harmony export getUtagViewData */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var generateAnalyticsData = function generateAnalyticsData(dealData) {
  var _dealData$categories, _dealData$categories$;

  return {
    link_type: "o",
    link_name: "shopping: deal details: add to cart",
    sales_event: "cart_add",
    sales_order_discount: dealData === null || dealData === void 0 ? void 0 : dealData.save_monthly_recurring,
    page_channel: "shopping",
    page_name: "shopping: deal details",
    page_master_tab: "personal",
    sales_product_id: [dealData === null || dealData === void 0 ? void 0 : dealData.sku],
    sales_product_quantity: [1],
    sales_product_category: [dealData === null || dealData === void 0 ? void 0 : (_dealData$categories = dealData.categories) === null || _dealData$categories === void 0 ? void 0 : (_dealData$categories$ = _dealData$categories[0]) === null || _dealData$categories$ === void 0 ? void 0 : _dealData$categories$.name],
    sales_product_price: ["".concat(dealData === null || dealData === void 0 ? void 0 : dealData.monthly_recurring)]
  };
};
var getUtagViewData = function getUtagViewData() {
  return _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .getUtagData */ .GS(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
};
var tagContinueShopping = function tagContinueShopping() {
  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .getUtagData */ .GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "sales_product_category", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4"])), {}, {
    link_type: "o",
    link_name: "shopping: deal details: continue shopping"
  }));
};
var tagJourneyChange = function tagJourneyChange() {
  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .view */ .ei(_objectSpread(_objectSpread({}, getUtagViewData()), {}, {
    page_name: "shopping: upgrade: journey change"
  }));
};
var tagJourneyChangeDismiss = function tagJourneyChangeDismiss() {
  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .link */ .p4(_objectSpread(_objectSpread({}, getUtagViewData()), {}, {
    page_tool_event: "use",
    page_tool_name: "shopping: upgrade: journey change: dismiss"
  }));
};
var tagJourneyChangeUse = function tagJourneyChangeUse(toolName) {
  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .link */ .p4(_objectSpread(_objectSpread({}, getUtagViewData()), {}, {
    page_tool_event: "use",
    page_tool_name: "shopping: upgrade: journey change: ".concat(toolName)
  }));
};
var tagSessionUpdate = function tagSessionUpdate(dealData, label, productTaggingInfo) {
  var _dealData$categories2, _dealData$categories3;

  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .link */ .p4(_objectSpread(_objectSpread({}, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .getUtagData */ .GS()), {}, {
    link_type: "o",
    link_name: "shopping: deal details: ".concat(label),
    sales_event: label.replace(/ /g, "_"),
    sales_product_id: [dealData === null || dealData === void 0 ? void 0 : dealData.sku],
    sales_product_quantity: [1],
    sales_product_category: [dealData === null || dealData === void 0 ? void 0 : (_dealData$categories2 = dealData.categories) === null || _dealData$categories2 === void 0 ? void 0 : (_dealData$categories3 = _dealData$categories2[0]) === null || _dealData$categories3 === void 0 ? void 0 : _dealData$categories3.name],
    sales_product_price: dealData === null || dealData === void 0 ? void 0 : dealData.monthly_recurring,
    sales_order_discount: dealData === null || dealData === void 0 ? void 0 : dealData.save_monthly_recurring,
    product_sku: productTaggingInfo.product_sku,
    product_colour: productTaggingInfo.product_colour,
    product_capacity: productTaggingInfo.product_capacity,
    product_brand: productTaggingInfo.product_brand
  }));
};
var tagViewCart = function tagViewCart(analyticsData) {
  _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .link */ .p4(_objectSpread(_objectSpread({}, analyticsData), {}, {
    link_type: "o",
    link_name: "shopping: devices: deal details: view cart",
    sales_event: "view cart"
  }));
};

/***/ }),

/***/ 69633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var VasContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  vasAvailable: false,
  setVasAvailable: function setVasAvailable() {//code
  },
  dealSKU: undefined,
  setDealSKU: function setDealSKU() {//code
  },
  vasList: [],
  setVasList: function setVasList() {//code
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (VasContext);

/***/ }),

/***/ 46224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ useProductTaggingInfo; },
/* harmony export */   "Sv": function() { return /* binding */ useCartBundleOptions; },
/* harmony export */   "c6": function() { return /* binding */ useDeviceStockStatus; },
/* harmony export */   "dL": function() { return /* binding */ useInclusionStockStatus; },
/* harmony export */   "og": function() { return /* binding */ useDealInCartStatus; },
/* harmony export */   "xt": function() { return /* binding */ useDealSelectionSummary; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27812);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var utils_dealDetails__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72490);
/* harmony import */ var _config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58223);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99599);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * @typedef {Object} StockState
 * @property {boolean} isInStock - unique id
 * @property {boolean} isBackOrder - name of color
 */

/**
 * Method to get the stock status of the primary (and secondary for double deal) device
 *
 * @returns {StockState} true if device (both) is IN_STOCK, false if device (both) is OUT_OF_STOCK
 */

var useDeviceStockStatus = function useDeviceStockStatus() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isInStock = _useState[0],
      setIsInStock = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isBackOrder = _useState2[0],
      setIsBackOrder = _useState2[1];

  var selectedPrimaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.dealDetails.selectedPrimaryDeviceColor;
  });
  var selectedSecondaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.dealDetails.selectedSecondaryDeviceColor;
  });
  var isSimOnly = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails$se;

    return !!((_state$dealDetails$se = state.dealDetails.selectedDealDetails) !== null && _state$dealDetails$se !== void 0 && _state$dealDetails$se.sim_only_flg);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _selectedPrimaryDevic, _selectedPrimaryDevic2;

    var isPrimaryDeviceInStock = (selectedPrimaryDeviceColor === null || selectedPrimaryDeviceColor === void 0 ? void 0 : (_selectedPrimaryDevic = selectedPrimaryDeviceColor.product) === null || _selectedPrimaryDevic === void 0 ? void 0 : _selectedPrimaryDevic.stock_status) === _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .StockStatus.IN_STOCK */ .BQ.IN_STOCK || isSimOnly;
    var isPrimaryDeviceInBackOrder = isPrimaryDeviceInStock && (selectedPrimaryDeviceColor === null || selectedPrimaryDeviceColor === void 0 ? void 0 : (_selectedPrimaryDevic2 = selectedPrimaryDeviceColor.product) === null || _selectedPrimaryDevic2 === void 0 ? void 0 : _selectedPrimaryDevic2.quantity) <= 0;

    if (!selectedSecondaryDeviceColor || Object.values(selectedSecondaryDeviceColor).length === 0) {
      setIsInStock(isPrimaryDeviceInStock);
      setIsBackOrder(isPrimaryDeviceInBackOrder);
    } else {
      var _selectedSecondaryDev, _selectedPrimaryDevic3;

      var isSecondaryDeviceInStock = (selectedSecondaryDeviceColor === null || selectedSecondaryDeviceColor === void 0 ? void 0 : (_selectedSecondaryDev = selectedSecondaryDeviceColor.product) === null || _selectedSecondaryDev === void 0 ? void 0 : _selectedSecondaryDev.stock_status) === _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .StockStatus.IN_STOCK */ .BQ.IN_STOCK;
      var isSecondaryDeviceInBackOrder = isPrimaryDeviceInStock && (selectedPrimaryDeviceColor === null || selectedPrimaryDeviceColor === void 0 ? void 0 : (_selectedPrimaryDevic3 = selectedPrimaryDeviceColor.product) === null || _selectedPrimaryDevic3 === void 0 ? void 0 : _selectedPrimaryDevic3.quantity) <= 0;
      setIsInStock(isPrimaryDeviceInStock && isSecondaryDeviceInStock);
      setIsBackOrder(isSecondaryDeviceInBackOrder);
    }
  }, [selectedPrimaryDeviceColor, selectedSecondaryDeviceColor]);
  return {
    isInStock: isInStock,
    isBackOrder: isBackOrder
  };
};
var useDealInCartStatus = function useDealInCartStatus() {
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isDealInCart = _useState3[0],
      setDealInCart = _useState3[1];

  var cartProductItems = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.cartDetails.cartProductItems;
  });
  var selectedDealDetails = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.dealDetails.selectedDealDetails;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!Array.isArray(cartProductItems) || !cartProductItems.length || !selectedDealDetails || Object.values(selectedDealDetails).length === 0) {
      setDealInCart(false);
      return;
    }

    var isDealInCart = cartProductItems.some(function (cartProduct) {
      var _cartProduct$product, _cartProduct$product2;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.sku) === selectedDealDetails.sku;
    });
    setDealInCart(isDealInCart);
  }, [selectedDealDetails, cartProductItems]);
  return isDealInCart;
};
/**
 * Method to get the stock status of the all inclusion devices with color options
 *
 * @returns {boolean} true if device (both) is IN_STOCK, false if device (both) is OUT_OF_STOCK
 */

var useInclusionStockStatus = function useInclusionStockStatus() {
  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isInStock = _useState4[0],
      setIsInStock = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isBackOrder = _useState5[0],
      setIsBackOrder = _useState5[1];

  var dealInclusionColors = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.dealDetails.dealInclusionColors;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!dealInclusionColors || !Array.isArray(Object.values(dealInclusionColors))) {
      setIsInStock(true);
      setIsBackOrder(false);
    } else {
      var selectedInclusionColors = Object.values(dealInclusionColors).map(function (ic) {
        return ic.selectedColor;
      });
      var isOutOfStock = selectedInclusionColors.some(function (ic) {
        var _ic$product;

        return (ic === null || ic === void 0 ? void 0 : (_ic$product = ic.product) === null || _ic$product === void 0 ? void 0 : _ic$product.stock_status) !== _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .StockStatus.IN_STOCK */ .BQ.IN_STOCK;
      });
      var isInBackOrder = selectedInclusionColors.some(function (ic) {
        var _ic$product2, _ic$product3;

        return (ic === null || ic === void 0 ? void 0 : (_ic$product2 = ic.product) === null || _ic$product2 === void 0 ? void 0 : _ic$product2.stock_status) === _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .StockStatus.IN_STOCK */ .BQ.IN_STOCK && (ic === null || ic === void 0 ? void 0 : (_ic$product3 = ic.product) === null || _ic$product3 === void 0 ? void 0 : _ic$product3.quantity) <= 0;
      });
      setIsInStock(!isOutOfStock);
      setIsBackOrder(isInBackOrder);
    }
  }, [dealInclusionColors]);
  return {
    isInStock: isInStock,
    isBackOrder: isBackOrder
  };
};
var useCartBundleOptions = function useCartBundleOptions() {
  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      bundleOptions = _useState6[0],
      setBundleOptions = _useState6[1];

  var dealDetails = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails;

    return (_state$dealDetails = state.dealDetails) === null || _state$dealDetails === void 0 ? void 0 : _state$dealDetails.selectedDealDetails;
  });
  var selectedPrimaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails2;

    return (_state$dealDetails2 = state.dealDetails) === null || _state$dealDetails2 === void 0 ? void 0 : _state$dealDetails2.selectedPrimaryDeviceColor;
  });
  var selectedSecondaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails3;

    return (_state$dealDetails3 = state.dealDetails) === null || _state$dealDetails3 === void 0 ? void 0 : _state$dealDetails3.selectedSecondaryDeviceColor;
  });
  var dealInclusionColors = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails4;

    return (_state$dealDetails4 = state.dealDetails) === null || _state$dealDetails4 === void 0 ? void 0 : _state$dealDetails4.dealInclusionColors;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!Array.isArray(dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.items)) {
      return;
    }

    var productSelections = utils_dealDetails__WEBPACK_IMPORTED_MODULE_3__/* .createColorSelections */ .DT({
      selectedPrimaryDeviceColor: selectedPrimaryDeviceColor,
      selectedSecondaryDeviceColor: selectedSecondaryDeviceColor,
      dealInclusionColors: dealInclusionColors
    });
    var bundleOptions = [];
    dealDetails.items.forEach(function (bundle) {
      var configs = utils_dealDetails__WEBPACK_IMPORTED_MODULE_3__/* .createColorSelectionConfigs */ .k1(bundle === null || bundle === void 0 ? void 0 : bundle.options, productSelections);
      var values = bundle === null || bundle === void 0 ? void 0 : bundle.options.map(function (option) {
        return option.id;
      });
      var bundleOption = {
        id: bundle.option_id,
        quantity: _config_labels__WEBPACK_IMPORTED_MODULE_5__/* ["default"].lbl_cart_min_product_add_qty */ .Z.lbl_cart_min_product_add_qty,
        value: values
      };

      if (configs.count > 0) {
        var optionItems = configs.products.map(function (prodConfig) {
          return _objectSpread(_objectSpread({}, bundleOption), {}, {
            value: configs.count > 1 ? [prodConfig.id] : bundleOption.value,
            selected_configurable_option: prodConfig
          });
        });
        bundleOptions.push.apply(bundleOptions, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(optionItems));
      } else {
        bundleOptions.push(bundleOption);
      }
    });
    setBundleOptions(bundleOptions);
  }, [dealDetails, selectedPrimaryDeviceColor, selectedSecondaryDeviceColor, dealInclusionColors]);
  return bundleOptions;
};
var useDealSelectionSummary = function useDealSelectionSummary() {
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      dealSelectionSum = _useState7[0],
      setDealSelectionSum = _useState7[1];

  var isSimOnly = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails5, _state$dealDetails5$s;

    return (_state$dealDetails5 = state.dealDetails) === null || _state$dealDetails5 === void 0 ? void 0 : (_state$dealDetails5$s = _state$dealDetails5.selectedDealDetails) === null || _state$dealDetails5$s === void 0 ? void 0 : _state$dealDetails5$s.sim_only_flg;
  });
  var primaryProduct = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails6;

    return (_state$dealDetails6 = state.dealDetails) === null || _state$dealDetails6 === void 0 ? void 0 : _state$dealDetails6.primaryProduct;
  });
  var secondaryProduct = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails7;

    return (_state$dealDetails7 = state.dealDetails) === null || _state$dealDetails7 === void 0 ? void 0 : _state$dealDetails7.secondaryProduct;
  });
  var selectedPrimaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails8;

    return (_state$dealDetails8 = state.dealDetails) === null || _state$dealDetails8 === void 0 ? void 0 : _state$dealDetails8.selectedPrimaryDeviceColor;
  });
  var selectedSecondaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails9;

    return (_state$dealDetails9 = state.dealDetails) === null || _state$dealDetails9 === void 0 ? void 0 : _state$dealDetails9.selectedSecondaryDeviceColor;
  });
  var dealInclusionColors = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails10;

    return (_state$dealDetails10 = state.dealDetails) === null || _state$dealDetails10 === void 0 ? void 0 : _state$dealDetails10.dealInclusionColors;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!primaryProduct || !Object.keys(primaryProduct).length) {
      return;
    }

    var dealProducts = []; // Primary device

    if (selectedPrimaryDeviceColor && Object.values(selectedPrimaryDeviceColor).length) {
      var _selectedPrimaryDevic4;

      dealProducts.push({
        groupid: primaryProduct.sku,
        line500CODE: (_selectedPrimaryDevic4 = selectedPrimaryDeviceColor.product) === null || _selectedPrimaryDevic4 === void 0 ? void 0 : _selectedPrimaryDevic4.sku,
        deviceType: _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes.PrimaryDevice */ .h7.PrimaryDevice,
        color: selectedPrimaryDeviceColor.value,
        colorLabel: selectedPrimaryDeviceColor.label
      });
    } else {
      dealProducts.push({
        groupid: primaryProduct.sku,
        line500CODE: primaryProduct.sku,
        deviceType: _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes.PrimaryDevice */ .h7.PrimaryDevice,
        color: '',
        colorLabel: ''
      });
    }

    if (isSimOnly) {
      setDealSelectionSum(dealProducts);
      return;
    } // Secondary Device (for double deal only)


    if (selectedSecondaryDeviceColor && Object.values(selectedSecondaryDeviceColor).length) {
      var _selectedSecondaryDev2;

      dealProducts.push({
        groupid: secondaryProduct.sku,
        line500CODE: (_selectedSecondaryDev2 = selectedSecondaryDeviceColor.product) === null || _selectedSecondaryDev2 === void 0 ? void 0 : _selectedSecondaryDev2.sku,
        deviceType: _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes.SecondaryDevice */ .h7.SecondaryDevice,
        color: selectedSecondaryDeviceColor.value,
        colorLabel: selectedSecondaryDeviceColor.label
      });
    } // Deal Inclusions


    if (Object.values(dealInclusionColors).length > 0) {
      var inclusionColorCodes = Object.values(dealInclusionColors).map(function (dic) {
        var _dic$selectedColor, _dic$selectedColor$pr, _dic$selectedColor2, _dic$selectedColor3;

        return {
          groupid: dic === null || dic === void 0 ? void 0 : dic.groupId,
          line500CODE: dic === null || dic === void 0 ? void 0 : (_dic$selectedColor = dic.selectedColor) === null || _dic$selectedColor === void 0 ? void 0 : (_dic$selectedColor$pr = _dic$selectedColor.product) === null || _dic$selectedColor$pr === void 0 ? void 0 : _dic$selectedColor$pr.sku,
          deviceType: _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes */ .h7 === null || _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes */ .h7 === void 0 ? void 0 : _config_constants__WEBPACK_IMPORTED_MODULE_4__/* .DeviceTypes.Inclusion */ .h7.Inclusion,
          color: dic === null || dic === void 0 ? void 0 : (_dic$selectedColor2 = dic.selectedColor) === null || _dic$selectedColor2 === void 0 ? void 0 : _dic$selectedColor2.value,
          colorLabel: dic === null || dic === void 0 ? void 0 : (_dic$selectedColor3 = dic.selectedColor) === null || _dic$selectedColor3 === void 0 ? void 0 : _dic$selectedColor3.label
        };
      });
      dealProducts.push.apply(dealProducts, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(inclusionColorCodes));
    }

    setDealSelectionSum(dealProducts);
  }, [isSimOnly, primaryProduct, selectedPrimaryDeviceColor, selectedSecondaryDeviceColor, dealInclusionColors]);
  return dealSelectionSum;
};
var useProductTaggingInfo = function useProductTaggingInfo() {
  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      productTagInfo = _useState8[0],
      setProductTagInfo = _useState8[1];

  var isSimOnly = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails11, _state$dealDetails11$;

    return (_state$dealDetails11 = state.dealDetails) === null || _state$dealDetails11 === void 0 ? void 0 : (_state$dealDetails11$ = _state$dealDetails11.selectedDealDetails) === null || _state$dealDetails11$ === void 0 ? void 0 : _state$dealDetails11$.sim_only_flg;
  });
  var primaryProduct = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails12;

    return (_state$dealDetails12 = state.dealDetails) === null || _state$dealDetails12 === void 0 ? void 0 : _state$dealDetails12.primaryProduct;
  });
  var secondaryProduct = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails13;

    return (_state$dealDetails13 = state.dealDetails) === null || _state$dealDetails13 === void 0 ? void 0 : _state$dealDetails13.secondaryProduct;
  });
  var selectedPrimaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails14;

    return (_state$dealDetails14 = state.dealDetails) === null || _state$dealDetails14 === void 0 ? void 0 : _state$dealDetails14.selectedPrimaryDeviceColor;
  });
  var selectedSecondaryDeviceColor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    var _state$dealDetails15;

    return (_state$dealDetails15 = state.dealDetails) === null || _state$dealDetails15 === void 0 ? void 0 : _state$dealDetails15.selectedSecondaryDeviceColor;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!primaryProduct || !selectedPrimaryDeviceColor) {
      return;
    }

    var newProductTagInfo = {
      product_sku: [],
      product_colour: [],
      product_capacity: [],
      product_brand: []
    };
    newProductTagInfo.product_sku.push(primaryProduct.sku);

    if (isSimOnly) {
      setProductTagInfo(newProductTagInfo);
      return;
    }

    newProductTagInfo.product_colour.push(selectedPrimaryDeviceColor === null || selectedPrimaryDeviceColor === void 0 ? void 0 : selectedPrimaryDeviceColor.label);
    newProductTagInfo.product_capacity.push(primaryProduct.internal_storage_label);
    newProductTagInfo.product_brand.push(primaryProduct.manufacturer_label);

    if (secondaryProduct && !!Object.keys(secondaryProduct).length) {
      newProductTagInfo.product_sku.push(secondaryProduct.sku);
      newProductTagInfo.product_colour.push(selectedSecondaryDeviceColor === null || selectedSecondaryDeviceColor === void 0 ? void 0 : selectedSecondaryDeviceColor.label);
      newProductTagInfo.product_capacity.push(secondaryProduct.internal_storage_label);
      newProductTagInfo.product_brand.push(secondaryProduct.manufacturer_label);
    }

    setProductTagInfo(newProductTagInfo);
  }, [primaryProduct, secondaryProduct, selectedPrimaryDeviceColor, selectedSecondaryDeviceColor, isSimOnly]);
  return productTagInfo;
};

/***/ }),

/***/ 88447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label-text":"LabelText_label-text__ss__o"};

/***/ }),

/***/ 59107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddedToCartPopup_modal__tGIgZ","img":"AddedToCartPopup_img__YnTD_","btn":"AddedToCartPopup_btn__gM_k9","label":"AddedToCartPopup_label__FLcSu","btn-link":"AddedToCartPopup_btn-link__Cj6cw"};

/***/ })

}]);